import {
  CALL_TO_ACTION_LEARN_MORE,
  CALL_TO_ACTION_OPTION,
  IS_ITEM_FORM_OPENED,
  STATUS
} from '../../../../Facebook/AdForms/fields'

import {
  NAME,
  CLICK_THROUGH_LINK,
  HEADLINES_LIST,
  DESCRIPTIONS_LIST,
  LANDSCAPE_IMAGE,
  initialGoogleFile,
  SQUARE_IMAGE,
  SQUARE_LOGO,
  LANDSCAPE_LOGO,
  BUSINESS_NAME,
  getInitialTextList
} from '../../fields'
import { IS_QUARANTINE } from '../../../../reusableFields'

export const LONG_HEADLINE = 'long_headline'

export const getInitialValues = (partnerName, isInternalAdCreation) => {
  return {
    [NAME]: '',
    [BUSINESS_NAME]: partnerName,
    [CLICK_THROUGH_LINK]: 'https://', // CLICK TROUGH LINK
    [HEADLINES_LIST]: getInitialTextList(3, ''),
    [DESCRIPTIONS_LIST]: getInitialTextList(2, ''),
    [LONG_HEADLINE]: '',
    [IS_ITEM_FORM_OPENED]: true,
    [LANDSCAPE_IMAGE]: [initialGoogleFile],
    [SQUARE_IMAGE]: [initialGoogleFile],
    [SQUARE_LOGO]: [initialGoogleFile],
    [LANDSCAPE_LOGO]: [initialGoogleFile],
    [CALL_TO_ACTION_OPTION]: CALL_TO_ACTION_LEARN_MORE,
    [STATUS]: 'paused',
    [IS_QUARANTINE]: isInternalAdCreation
  }
}
